import { Api } from 'utils';

class CalendarService {

	static get = async (params?: any) => Api.createResponse('client/calendar',params);
	static save = async (params?: any) => Api.createResponse('client/calendar/save',params);

}

export default CalendarService;